import React, { Fragment } from 'react';
import styled from 'styled-components';

import { StoreProduct } from '../../models/StoreProduct';
import ProductsTableRow from './ProductsTableRow';

interface ComponentProps {
  storeProducts: StoreProduct[];
  onEditStoreProduct: (storeProduct: StoreProduct) => void;
  onRemoveStoreProduct: (storeProduct: StoreProduct) => void;
}

const ProductsTable = ({
  storeProducts,
  onEditStoreProduct,
  onRemoveStoreProduct,
}: ComponentProps) => {
  return (
    <TableContainer>
      <Table>
        <ProductsTableHead>
          <tr>
            <th className="product-header">Imagem</th>
            <th className="product-header">Produto</th>
            {/* <th className="description-header">Descrição</th> */}
            <th className="price-header">Preço (coins) </th>
            <th className="cash-price-header">Preço (R$)</th>
            <th className="stock-quantity-header">Estoque</th>
            <th className="tags-header">Tags</th>
            {/* <th className="created-at-header">Criado em</th> */}
          </tr>
        </ProductsTableHead>
        <tbody>
          {storeProducts.map((storeProduct, index) => (
            <Fragment key={storeProduct.id}>
              <ProductsTableRow
                storeProduct={storeProduct}
                onEditProduct={onEditStoreProduct}
                onRemoveProduct={onRemoveStoreProduct}
              />
              {index < storeProducts.length - 1 && (
                <TableRowDivider>
                  <td className="divider" colSpan={4} />
                </TableRowDivider>
              )}
            </Fragment>
          ))}
        </tbody>
      </Table>
    </TableContainer>
  );
};

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  margin: 1rem 0;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: 'Inter', sans-serif;
`;

export const ProductsTableHead = styled.thead`
  th {
    text-align: left;
    font-size: 0.875rem;
    font-weight: 600;
  }

  .product-header {
    width: 20%;
  }

  .description-header {
    width: 40%;
  }

  /* adicione outras classes de th conforme necessário */
`;

export const TableBodyRow = styled.tr`
  &:hover {
  }

  td {
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
    vertical-align: middle;
  }
`;

export const TableRowDivider = styled.tr`
  .divider {
    height: 1px;
    width: 100%;
  }
`;

export default ProductsTable;
